import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Admin.css';

const Admin = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('admin_logged_in') === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const res = await fetch(process.env.REACT_APP_ADMIN_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const result = await res.json();
      setMessage(result.message);

      if (result.success) {
        localStorage.setItem('admin_logged_in', 'true');
        localStorage.setItem('admin_username', form.username);
        navigate('/dashboard');
      }
    } catch (err) {
      setMessage('Something went wrong');
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-form-wrapper">
        <h2>Admin Login</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Login</button>
          {message && <p>{message}</p>}
        </form>

        <div className="toggle-button">
          <button onClick={() => navigate('/')}>
            Back to Home Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin;
